import { render, staticRenderFns } from "./RosterCreate.vue?vue&type=template&id=63a955ab&scoped=true"
import script from "./RosterCreate.vue?vue&type=script&lang=js"
export * from "./RosterCreate.vue?vue&type=script&lang=js"
import style0 from "./RosterCreate.vue?vue&type=style&index=0&id=63a955ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a955ab",
  null
  
)

export default component.exports